<template>
	<div>
		<div class="input-wrapper" :class="{'input-wrapper-tooltip': tooltip, 'has-focus': (value && value.length > 0), 'has-error': error.length > 0}">
			<div class="input-label" :class="{'has-icon': icon}">
				{{ label }} {{ required ? "*" : "" }}
			</div>
			
			<i :class="['input-icon', 'fa', 'fa-fw', icon]" v-if="icon"></i>

			<Datepicker :date="internal" :option="options" ref="datepicker"/>

			<div class="input-error">
				{{ error }}
			</div>
		</div>
		<div v-if="tooltip" class="input-tooltip" v-popover:tooltip.left="tooltip">
			<i class="fas fa-question-circle"></i>
		</div>
	</div>
</template>


<script>
	import Datepicker from 'vue-datepicker';

	export default {
		name: "FormDate",

		components: { Datepicker },

		props: {
			icon: {
				type: String,
				require: false,
				default: undefined,
			},
			label: {
				type: String,
				require: false,
			},
			value: {
				type: String,
				require: false,
				default: undefined,
			},
			tooltip: {
				type: String,
				require: false,
			},
			required: {
				type: Boolean,
				require: false,
				default: false,
			},
		},

		watch: {
			internal: {
				handler(val) {
					this.$emit("input", val.time);
				},
				deep: true,
			},

			value: function() {
				this.validate();
			}
		},

		data: function() {
			let data = {
				internal: {
					time: this.value,
				},

				error: "",

				options: {
					type: 'day',
					week: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'],
					month: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
					format: 'DD/MM/YYYY',

					placeholder: "",

					inputStyle: {
						'position': 'absolute',
						'top': '20px',
						'width': '100%',
						'border': 'none',
						'border-bottom': '1px solid #aaa',
						'height': '40px',
						'line-height': '40px',
						'background': 'none',
					},

					buttons: {
						ok: 'Ok',
						cancel: 'Cancelar'
					},
				},
			};

			if (this.icon != undefined) {
				data.options.inputStyle['padding-left'] = '40px';
			}

			return data;
		},

		methods: {
			validate: function() {
				if (this.required) {
					if (this.internal.time.length == 0) {
						this.error = "* " + this.label + " é obrigatório.";
						return;
					}
				}

				this.error = "";
			},
			clear_date: function() {
				if(this.$refs && this.$refs.datepicker.date && this.$refs.datepicker.date) {
					this.$refs.datepicker.date.time = "";
				}				
			}
		}
	}
</script>


<style scoped>
.input-wrapper {
	position: relative;
	width: 100%;
	height: 90px;
	color: #666;
	margin-bottom: 10px;
	display: inline;
	float: left;
}

.input-wrapper-tooltip {
	width: calc(100% - 20px);
}

.input-label {
	position: absolute;
	width: 100%;
	height: 25px;
	line-height: 30px;
	top: 25px;
	color: #999;
	transition: all 0.2s linear;
}

.has-focus .input-label {
	top: 0;
	left: 0 !important;
	font-size: 12px;
	color: #666;
}

.has-error .input-label {
	color: red;
}





.input-element {
	position: absolute;
	top: 20px;
	width: 100%;
	border: none;
	border-bottom: 1px solid #aaa;
	height: 40px;
	line-height: 40px;
	background: none;
}

.has-error .input-element {
	border-bottom: 1px solid red;
}




.input-error {
	width: 100%;
	position: absolute;
	top: 60px;
	font-size: 12px;
	height: 25px;
	line-height: 35px;
}

.has-error .input-error {
	color: red;
}







.input-element.has-icon {
	padding-left: 40px;
}

.input-label.has-icon {
	left: 40px;
	width: calc(100% - 40px);
}

.input-icon {
	position: absolute;
	top: 18px;
	width: 40px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	color: #666;
}


.has-error .input-icon {
	color: red;
}
</style>